'use client';

function handleAriaDescribedBy({ error, caption }, descriptionId, { "aria-describedby": other = "" }) {
  const hasDescription = !!error || !!caption;
  if (!hasDescription && !other) return {};
  const spaceIfNeeded = hasDescription && other ? " " : "";
  return {
    "aria-describedby": `${descriptionId}${spaceIfNeeded}${other}`
  };
}
export {
  handleAriaDescribedBy
};
